import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=ecdae8a2&scoped=true"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"
import style0 from "./popover.vue?vue&type=style&index=0&id=ecdae8a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecdae8a2",
  null
  
)

export default component.exports